/**
 * Part of unicorn project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

export class CheckboxesMultiSelect {
  defaultOptions = {
    duration: 100,
    inputSelector: 'input[type=checkbox][data-role=grid-checkbox]'
  }

  static handle(selector, options = {}) {
    return u.selectAll(selector, (ele) => {
      return new this(ele, options);
    });
  }

  constructor(selector, options = {}) {
    this.$element = u.selectOne(selector);
    this.options = Object.assign({}, this.defaultOptions, options);
    this.boxes = this.$element.querySelectorAll(this.options.inputSelector);
    this.last = false;

    u.selectAll(this.boxes, (box) => {
      box.addEventListener('click', (e) => {
        this.select(box, e);
      });
    });
  }

  select(box, event) {
    if (!this.last) {
      this.last = box;

      return;
    }

    if (event.shiftKey) {
      const start = this.boxes.indexOf(box);
      const end = this.boxes.indexOf(this.last);

      const chs = this.boxes.slice(Math.min(start, end), Math.max(start, end) + 1);

      [].forEach.call(chs, (ele, i) => {
        ele.checked = this.last.checked;
      });
    }

    this.last = box;
  }
}
